import { CoreLogin } from '@bepatient/core';
import { Observable } from 'rxjs';
import { BirthdateFormat, Onboarding } from './onboarding.models';

/**
 * @ignore
 */

export abstract class OnboardingApiService {
  abstract loadOnboarding(): Observable<Onboarding>;
  abstract authorize(
    email: string,
    birthdate?: string,
    fcmToken?: string,
    deviceType?: string,
    userTimezone?: string,
    appVersion?: string
  ): Observable<Partial<CoreLogin>>;
  abstract getBirthdateFormat(apiDateFormat: string): BirthdateFormat;
  abstract passwordReset(
    data: any,
    deviceType?: string,
    appVersion?: string
  ): Observable<Partial<CoreLogin>>;
  abstract changePassword(
    email: string,
    birthdate?: string,
    deviceType?: string,
    appVersion?: string
  ): Observable<any>;
  abstract onboardingSubmitStep(
    object: any,
    deviceType?: string,
    appVersion?: string
  ): Observable<Partial<CoreLogin>>;
  abstract onboardingFinalize(): Observable<Partial<CoreLogin>>;
  abstract loadOnboardingTosDetails?(url: string): Observable<any>;
}
